/* ==========================================================================
   RAWTORQUE MOBILE DRAWER · v4.16
   ========================================================================== */
(function () {
  'use strict';

  if (window.__rtDrawerInit) return;
  window.__rtDrawerInit = true;

  var DRAWER_OPEN_CLASS = 'm2a';
  var OFFER_THRESHOLD   = 3;
  var LS_BRAND_KEY      = 'rt_garage_brand';
  var LS_TYPE_KEY       = 'rt_garage_type';
  var ICON_BIKE = 'https://cdn.shopify.com/s/files/1/0953/0549/8989/files/motorbike.png?v=1777967937';
  var ICON_CAR  = 'https://cdn.shopify.com/s/files/1/0953/0549/8989/files/car.png?v=1777967938';

  var BIKES = ['Aprilia','Ather','Bajaj','Benelli','BMW','CF Moto','Ducati','Harley-Davidson','Hero','Honda','Jawa','Kawasaki','KTM','Ola Electric','Revolt','Royal Enfield','Suzuki','Triumph','TVS','Vespa','Yamaha','Yezdi'];
  var CARS  = ['Audi','BMW','Citroën','Ford','Honda Cars','Hyundai','Isuzu','Jeep','Kia','Mahindra','Maruti Suzuki','Mercedes-Benz','MG','Nissan','Renault','Skoda','Tata','Toyota','Volkswagen','Volvo'];

  var NAV_ICONS = [
    { kw:['bike','bikes','motorcycle','two wheel','by bike'], img:ICON_BIKE, svg:'<circle cx="5.5" cy="17.5" r="2.5" stroke="currentColor" stroke-width="1.6"/><circle cx="18.5" cy="17.5" r="2.5" stroke="currentColor" stroke-width="1.6"/><path d="M5.5 17.5L8 11l5 .5 3-4 2.5 2.5M14 11.5l1 6" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>' },
    { kw:['car','auto','vehicle','4 wheel','by car'], img:ICON_CAR, svg:'<rect x="2" y="9" width="20" height="10" rx="2" stroke="currentColor" stroke-width="1.6"/><path d="M5 9l2-4h10l2 4" stroke="currentColor" stroke-width="1.6"/><circle cx="7.5" cy="19" r="1.5" fill="currentColor"/><circle cx="16.5" cy="19" r="1.5" fill="currentColor"/>' },
    { kw:['category','categories','shop by category','browse'], svg:'<rect x="3" y="3" width="7" height="7" rx="1.5" stroke="currentColor" stroke-width="1.6"/><rect x="14" y="3" width="7" height="7" rx="1.5" stroke="currentColor" stroke-width="1.6"/><rect x="3" y="14" width="7" height="7" rx="1.5" stroke="currentColor" stroke-width="1.6"/><rect x="14" y="14" width="7" height="7" rx="1.5" stroke="currentColor" stroke-width="1.6"/>' },
    { kw:['helmet','lid','head'], svg:'<path d="M12 2C8 2 4 5.5 4 10c0 2 .8 3.8 2 5.1L5 20h14l-1-4.9A8 8 0 0020 10c0-4.5-4-8-8-8z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/><path d="M9 13h6" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>' },
    { kw:['exhaust','muffler','pipe','silencer'], svg:'<path d="M4 9h16M4 12h13M4 15h10M17 12l4 4-4 0" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>' },
    { kw:['brake','disc','pad','caliper','rotor'], svg:'<circle cx="12" cy="12" r="8" stroke="currentColor" stroke-width="1.6"/><circle cx="12" cy="12" r="3.5" stroke="currentColor" stroke-width="1.6"/><path d="M12 4v2M12 18v2M4 12H6M18 12h2" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>' },
    { kw:['tyre','tire','tube','wheel','rim'], svg:'<circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="1.6"/><circle cx="12" cy="12" r="4" stroke="currentColor" stroke-width="1.6"/><path d="M12 3v3M12 18v3M3 12h3M18 12h3" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>' },
    { kw:['light','led','headlight','indicator','lamp','bulb','lighting'], svg:'<circle cx="12" cy="11" r="4" stroke="currentColor" stroke-width="1.6"/><path d="M12 2v2M12 18v2M2 11h2M18 11h2M5.6 4.6l1.4 1.4M16.9 16l1.4 1.4M5.6 17.4l1.4-1.4M16.9 6l1.4-1.4" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>' },
    { kw:['engine','piston','oil','filter','spark','plug'], svg:'<rect x="6" y="8" width="12" height="10" rx="1.5" stroke="currentColor" stroke-width="1.6"/><path d="M9 8V5a3 3 0 016 0v3M9 13h6" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>' },
    { kw:['protection','guard','crash','protector','bash'], svg:'<path d="M12 2l9 4.5V12c0 5.25-3.75 9.75-9 11C6.75 21.75 3 17.25 3 12V6.5L12 2z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/>' },
    { kw:['accessory','accessories','luggage','bag','mount'], svg:'<rect x="3" y="8" width="18" height="12" rx="2" stroke="currentColor" stroke-width="1.6"/><path d="M9 8V6a3 3 0 016 0v2" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>' },
    { kw:['brand','brands','shop by brand'], svg:'<path d="M12 2l2.5 7.5H22l-6.5 4.7 2.5 7.5L12 17.2 5.5 21.7l2.5-7.5L1.5 9.5H9.5z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/>' },
    { kw:['best seller','best sellers','bestseller','top rated','popular'], svg:'<path d="M12 2l2.09 6.26H21l-5.5 4 2.09 6.26L12 14.52 6.41 18.52l2.09-6.26L3 8.26h6.91z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/>' },
    { kw:['sale','offer','deal','discount','clearance','on sale'], svg:'<path d="M12 2L2 12l10 10 10-10L12 2z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/><circle cx="9" cy="9" r="1" fill="currentColor"/><circle cx="15" cy="15" r="1" fill="currentColor"/><path d="M15 9L9 15" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>' },
    { kw:['new arrival','new arrivals','just in','latest','just launched'], svg:'<circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="1.6"/><path d="M12 8v4l3 3" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>' },
    { kw:['performance','upgrade','tuning','power','race','stage'], svg:'<path d="M13 2L3 14h8l-2 8 12-12h-8l2-8z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/>' },
    { kw:['home','homepage'], svg:'<path d="M3 12L12 3l9 9M5 10v10h5v-6h4v6h5V10" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>' },
    { kw:['about','who we'], svg:'<circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="1.6"/><path d="M12 8v1M12 11v5" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>' },
    { kw:['contact','reach'], svg:'<path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 9.81 19.79 19.79 0 01.12 1.18 2 2 0 012.11.11h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.91 7.91a16 16 0 006.35 6.35l1.27-.45a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>' },
    { kw:['blog','article','read'], svg:'<path d="M4 6h16M4 10h16M4 14h10" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/>' }
  ];

  var html, nav, hero, offerBar, greetingEyebrow, greetingTitle,
      garagePill, garageSelector, cartTileSub, cartTileBadge;
  var garageTab      = 'bikes';
  var garageSelected = { brand: null, type: null };

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }
  ready(init);

  function init() {
    html = document.documentElement;
    nav  = document.getElementById('nav');
    if (!nav) return;

    hero            = nav.querySelector('.rt-drawer-hero');
    offerBar        = nav.querySelector('.rt-drawer-offer');
    greetingEyebrow = nav.querySelector('.rt-drawer-greeting__eyebrow');
    greetingTitle   = nav.querySelector('.rt-drawer-greeting__title');
    garagePill      = nav.querySelector('#rt-garage-pill');
    cartTileSub     = nav.querySelector('.rt-drawer-quick__tile--cart .rt-drawer-quick__sub');
    cartTileBadge   = nav.querySelector('.rt-drawer-quick__tile--cart .rt-drawer-quick__badge');

    buildGarageSelector();
    restoreGarage();
    injectCloseButton();
    wireGaragePill();
    wireSearchInput();
    wireSwipeToClose();
    wireScrollShadow();
    wireRipple();
    wireCartBadgePop();
    watchNavHeaders();
    observeDrawerState();

    if (html.classList.contains(DRAWER_OPEN_CLASS)) onDrawerOpen();
  }

  /* ── CLOSE BUTTON ── */
  function injectCloseButton() {
    if (document.getElementById('rt-nav-close')) return;
    var btn = document.createElement('button');
    btn.id = 'rt-nav-close'; btn.type = 'button';
    btn.setAttribute('aria-label','Close menu');
    btn.innerHTML = '<svg width="12" height="12" viewBox="0 0 24 24" fill="none"><path d="M6 6L18 18M18 6L6 18" stroke="#555" stroke-width="2" stroke-linecap="round"/></svg>';
    btn.style.cssText = 'position:fixed;top:14px;right:14px;z-index:99999;display:none;align-items:center;justify-content:center;width:32px;height:32px;min-width:32px;min-height:32px;border-radius:50%;background:#ffffff;border:1.5px solid #ddd;box-shadow:0 2px 8px rgba(0,0,0,0.12);padding:0;margin:0;cursor:pointer;float:none;-webkit-tap-highlight-color:transparent;';
    btn.addEventListener('click', function(e){ e.preventDefault(); closeDrawer(); });
    document.body.appendChild(btn);
  }
  function showCloseButton(){ var b=document.getElementById('rt-nav-close'); if(b) b.style.display='flex'; }
  function hideCloseButton(){ var b=document.getElementById('rt-nav-close'); if(b) b.style.display='none'; }

  /* ── GARAGE SELECTOR ── */
  function buildGarageSelector() {
    if (!garagePill || document.getElementById('rt-garage-selector')) return;
    var sel = document.createElement('div');
    sel.className = 'rt-garage-selector'; sel.id = 'rt-garage-selector';
    sel.innerHTML =
      '<div class="rt-garage-selector__inner">' +
        '<div class="rt-gs-search">' +
          '<svg class="rt-gs-search__icon" viewBox="0 0 24 24" fill="none"><circle cx="11" cy="11" r="7" stroke="currentColor" stroke-width="1.8"/><path d="M20 20L17 17" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>' +
          '<input class="rt-gs-search__input" id="rt-gs-search-input" type="search" placeholder="Search brand\u2026" autocomplete="off">' +
        '</div>' +
        '<div class="rt-gs-tabs">' +
          '<button class="rt-gs-tab is-active" data-tab="bikes">Bikes</button>' +
          '<button class="rt-gs-tab" data-tab="cars">Cars</button>' +
        '</div>' +
        '<div class="rt-gs-list" id="rt-gs-list"></div>' +
      '</div>';
    garagePill.insertAdjacentElement('afterend', sel);
    garageSelector = sel;
    sel.querySelectorAll('.rt-gs-tab').forEach(function(tab){
      tab.addEventListener('click', function(){
        sel.querySelectorAll('.rt-gs-tab').forEach(function(t){ t.classList.remove('is-active'); });
        tab.classList.add('is-active'); garageTab = tab.dataset.tab;
        var si = sel.querySelector('#rt-gs-search-input'); if(si) si.value='';
        renderGarageList('');
      });
    });
    var si = sel.querySelector('#rt-gs-search-input');
    if (si) si.addEventListener('input', function(){ renderGarageList(si.value); });
    renderGarageList('');
  }

  function renderGarageList(query) {
    var list = document.getElementById('rt-gs-list'); if(!list) return;
    var brands = garageTab==='cars' ? CARS : BIKES;
    var q = (query||'').toLowerCase().trim();
    var filtered = q ? brands.filter(function(b){ return b.toLowerCase().indexOf(q)!==-1; }) : brands;
    if (!filtered.length){ list.innerHTML='<div class="rt-gs-empty">No brands found</div>'; return; }
    var isCar = garageTab==='cars';
    var iconSrc = isCar ? ICON_CAR : ICON_BIKE;
    var html_str = '';
    filtered.forEach(function(brand){
      var isSel = garageSelected.brand===brand;
      html_str += '<div class="rt-gs-brand'+(isSel?' is-selected':'')+'" data-brand="'+brand+'">' +
        '<div class="rt-gs-brand__left">' +
        '<img src="'+iconSrc+'" class="rt-gs-brand__icon" alt="" width="14" height="14" style="object-fit:contain;display:block;opacity:0.75">' +
        '<span class="rt-gs-brand__name">'+brand+'</span></div>' +
        (isSel ? '<svg class="rt-gs-brand__check" viewBox="0 0 24 24" fill="none"><path d="M5 12l5 5L19 7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>'
               : '<svg class="rt-gs-brand__chev" viewBox="0 0 24 24" fill="none"><path d="M9 6l6 6-6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>') +
        '</div>';
    });
    list.innerHTML = html_str;
    list.querySelectorAll('.rt-gs-brand').forEach(function(item){
      item.addEventListener('click', function(){
        var brand = item.dataset.brand;
        garageSelected = { brand: brand, type: garageTab==='cars'?'car':'bike' };
        try{ localStorage.setItem(LS_BRAND_KEY, brand); localStorage.setItem(LS_TYPE_KEY, garageSelected.type); }catch(e){}
        updateGaragePill(brand);
        updateGaragePillIcon(garageSelected.type);
        closeGarageSelector();
        updateGreeting();
      });
    });
  }

  function restoreGarage() {
    try{
      var b=localStorage.getItem(LS_BRAND_KEY), t=localStorage.getItem(LS_TYPE_KEY);
      if(b){ garageSelected={brand:b,type:t||'bike'}; garageTab=(t==='car')?'cars':'bikes'; updateGaragePill(b); updateGaragePillIcon(t||'bike'); }
    }catch(e){}
  }

  function updateGaragePill(brand){
    var el=document.getElementById('rt-garage-pill-brand'); if(el) el.textContent=brand;
  }

  function updateGaragePillIcon(type){
    var el=document.getElementById('rt-garage-pill-icon');
    if(el) el.src = type==='car' ? ICON_CAR : ICON_BIKE;
  }

  function wireGaragePill() {
    if (!garagePill) return;
    function toggle(e){ e.preventDefault(); e.stopPropagation();
      garagePill.classList.contains('is-open') ? closeGarageSelector() : openGarageSelector(); }
    garagePill.addEventListener('click', toggle);
    garagePill.addEventListener('keydown', function(e){ if(e.key==='Enter'||e.key===' '){ e.preventDefault(); toggle(e); } });
  }
  function openGarageSelector(){
    if(!garageSelector) return;
    garagePill.classList.add('is-open'); garageSelector.classList.add('is-open');
    var si=garageSelector.querySelector('#rt-gs-search-input'); if(si) si.value='';
    var target=garageSelected.type==='car'?'cars':'bikes';
    garageSelector.querySelectorAll('.rt-gs-tab').forEach(function(t){ t.classList.toggle('is-active',t.dataset.tab===target); });
    garageTab=target; renderGarageList('');
  }
  function closeGarageSelector(){
    if(garagePill) garagePill.classList.remove('is-open');
    if(garageSelector) garageSelector.classList.remove('is-open');
  }

  /* ── SEARCH INPUT ── */
  function wireSearchInput() {
    var input = nav && nav.querySelector('.rt-drawer-search__input');
    if (!input) return;
    function openSearch(e) {
      e.preventDefault(); e.stopPropagation();
      input.blur(); closeDrawer();
      setTimeout(function () {
        var toggle = document.querySelector('#header-outer [aria-controls="search"],.link-btn a[aria-controls="search"],a.search-compact[href="#search"]');
        if (toggle) { toggle.click(); return; }
        var searchEl = document.getElementById('search');
        var searchField = searchEl && searchEl.querySelector('input[type="search"]');
        if (searchEl) searchEl.classList.add('full','has-text');
        if (searchField) { html.classList.add('search-compact-active','search-full'); searchField.focus(); }
      }, 320);
    }
    input.addEventListener('click',    openSearch);
    input.addEventListener('touchend', function(e){ e.preventDefault(); openSearch(e); });
    input.addEventListener('focus',    function(e){ e.preventDefault(); input.blur(); });
    input.setAttribute('autocomplete','off');
  }

  /* ── AVATAR ── */
  function injectRiderAvatar() {
    var wrap = nav && nav.querySelector('.rt-drawer-avatar');
    if (!wrap || wrap.dataset.animated) return;
    wrap.dataset.animated = '1';

    wrap.innerHTML =
      '<img src="https://cdn.shopify.com/s/files/1/0953/0549/8989/files/racer.png?v=1777977164"' +
      '     width="26" height="26" alt=""' +
      '     style="display:block;object-fit:contain;">';

    wrap.style.animation = 'rt-avatar-ring 2.4s ease-out infinite';
  }

  /* ── GREETING ── */
  function updateGreeting() {
    if (!greetingEyebrow || !greetingTitle) return;
    /* Read customer name from data attribute on hero element - no script tag needed */
    var heroEl    = nav && nav.querySelector('.rt-drawer-hero');
    var firstName = heroEl ? heroEl.getAttribute('data-customer-name') : null;
    firstName     = (firstName && firstName.length > 0) ? firstName : null;
    var h = new Date().getHours();
    var ey, ti;

    if (firstName) {
      ey = h>=5&&h<12  ? 'Good morning, '+firstName+'!' :
           h>=12&&h<17 ? 'Good afternoon, '+firstName+'!' :
           h>=17&&h<21 ? 'Good evening, '+firstName+'!' :
           'Riding late, '+firstName+'?';
      ti = garageSelected.brand
        ? 'Parts for your '+garageSelected.brand+'?'
        : 'What are we building today?';
    } else {
      ey = h>=5&&h<12  ? 'Good morning, rider' :
           h>=12&&h<17 ? 'Good afternoon, rider' :
           h>=17&&h<21 ? 'Good evening, rider' :
           'Riding late?';
      ti = garageSelected.brand
        ? 'Parts for your '+garageSelected.brand+'?'
        : h>=5&&h<12  ? 'Ready to ride today?' :
          h>=12&&h<17 ? 'What are you building?' :
          h>=17&&h<21 ? 'Evening wrench session?' :
          "We've got the parts.";
    }

    greetingEyebrow.style.cssText += 'display:block!important;color:#E63946!important;';
    greetingTitle.style.cssText   += 'display:block!important;color:#111112!important;';
    greetingEyebrow.textContent = ey;
    greetingTitle.textContent   = ti;
  }

  /* ── OFFER BAR ── */
  function refreshOffer() {
    fetch('/cart.js').then(function(r){return r.json();}).then(function(cart){
      updateOfferBar(cart.item_count||0); updateCartTile(cart.item_count||0,cart.total_price||0);
    }).catch(function(){});
  }
  function updateOfferBar(count) {
    if(!offerBar) return;
    var reached=Math.min(count,OFFER_THRESHOLD), isDone=count>=OFFER_THRESHOLD;
    offerBar.querySelectorAll('[data-step]').forEach(function(dot){ var s=parseInt(dot.dataset.step,10); dot.classList.toggle('is-done',s<=reached); dot.classList.toggle('is-active',s===reached+1); });
    offerBar.querySelectorAll('[data-conn]').forEach(function(conn){ var c=parseInt(conn.dataset.conn,10); conn.classList.toggle('is-done',c<reached); conn.classList.toggle('is-active',c===reached); });
    offerBar.classList.toggle('is-done',isDone);
    var title=offerBar.querySelector('.rt-offer-title'), cta=offerBar.querySelector('.rt-offer-cta'), sub=offerBar.querySelector('.rt-offer-sub');
    if(isDone){ if(title) title.textContent='3% off unlocked!'; if(cta){cta.textContent='Applied at checkout';cta.classList.add('is-done');} if(sub) sub.innerHTML='Your 3% discount is applied automatically.'; }
    else{ var need=OFFER_THRESHOLD-count; if(title) title.textContent='3 products = 3% off'; if(cta){cta.textContent='Add '+need+' more \u2192';cta.classList.remove('is-done');} if(sub) sub.innerHTML=count===0?'Add 3 products to unlock <strong>3% off</strong> at checkout':'Add <strong>'+need+' more product'+(need>1?'s':'')+'</strong> to unlock 3% off'; }
  }
  function updateCartTile(count,totalPrice){
    if(cartTileBadge){cartTileBadge.textContent=count;cartTileBadge.style.display=count>0?'block':'none';}
    if(cartTileSub) cartTileSub.textContent=count>0?count+' item'+(count>1?'s':'')+' \u00b7 \u20b9'+(totalPrice/100).toLocaleString('en-IN'):'Your cart is empty';
  }

  /* ── STAGGER ── */
  function setStaggerIndex() {
    var cnav=document.getElementById('rt-cnav'); if(!cnav) return;
    /* RT FIX (INP): removed void tile.offsetHeight forced reflow.
       Original code did: animationName='none' → void offsetHeight → animationName=''
       The void offsetHeight triggered a synchronous layout recalculation.
       Fix: write animationName='none' for all tiles first (single write pass),
       then read one layout value once to flush, then clear all in a second write pass.
       Single read instead of one per tile - same visual result, zero per-tile reflow. */
    var tiles = cnav.querySelectorAll('.rt-tile');
    var qlinks = cnav.querySelectorAll('.rt-qlink');
    tiles.forEach(function(tile, i) {
      tile.style.setProperty('--ti', i);
      tile.style.animationName = 'none';
    });
    qlinks.forEach(function(link, i) {
      link.style.setProperty('--qi', i);
      link.style.animationName = 'none';
    });
    /* Single layout flush - one read instead of one per element */
    void cnav.offsetHeight;
    tiles.forEach(function(tile) { tile.style.animationName = ''; });
    qlinks.forEach(function(link) { link.style.animationName = ''; });
  }

  /* ── THEME CHROME ── */
  function watchNavHeaders() {
    if(!nav||!window.MutationObserver) return;
    new MutationObserver(function(muts){ muts.forEach(function(m){ m.addedNodes.forEach(function(node){ if(node.nodeType===1&&(node.classList.contains('header')||node.classList.contains('header-before'))) node.style.display='none'; }); }); }).observe(nav,{childList:true,subtree:true});
  }
  function forceHideNavHeaders() {
    if(!nav) return;
    nav.querySelectorAll('.header,.header-before').forEach(function(el){ if(!el.closest('.rt-drawer-hero')&&!el.id) el.style.display='none'; });
    nav.querySelectorAll('button.overlay-close,a.close:not(.rt-drawer-close)').forEach(function(el){ if(!el.id) el.style.display='none'; });
  }

  /* ── CLOSE DRAWER ── */
  function closeDrawer() {
    if(typeof window.close_mobile_nav==='function'){window.close_mobile_nav();return;}
    html.classList.remove(DRAWER_OPEN_CLASS);
    setTimeout(function(){html.classList.remove('m2a-delay');},360);
  }

  /* ── SWIPE TO CLOSE ── */
  function wireSwipeToClose() {
    var startX=0,startY=0,dragging=false,locked=null;
    nav.addEventListener('touchstart',function(e){ if(window.innerWidth>1000||!html.classList.contains(DRAWER_OPEN_CLASS))return; var t=e.touches[0];startX=t.clientX;startY=t.clientY;dragging=true;locked=null; },{passive:true});
    nav.addEventListener('touchmove',function(e){ if(!dragging)return; var t=e.touches[0],dx=t.clientX-startX,dy=t.clientY-startY; if(locked===null&&(Math.abs(dx)>8||Math.abs(dy)>8)) locked=Math.abs(dx)>Math.abs(dy)?'x':'y'; if(locked!=='x'||dx>=0)return; nav.style.transform='translateX('+Math.max(dx,-130)+'px)';nav.style.transition='none'; },{passive:true});
    function reset(){ if(!dragging)return; var m=nav.style.transform.match(/-?\d+(\.\d+)?/); nav.style.transition='';nav.style.transform='';dragging=false; if(m&&parseFloat(m[0])<=-60) closeDrawer(); }
    nav.addEventListener('touchend',reset); nav.addEventListener('touchcancel',reset);
  }

  /* ── SCROLL SHADOW ── */
  function wireScrollShadow() {
    if(!nav||!hero) return;
    var ticking=false;
    nav.addEventListener('scroll',function(){ if(ticking)return;ticking=true; requestAnimationFrame(function(){hero.classList.toggle('is-scrolled',nav.scrollTop>4);ticking=false;}); },{passive:true});
  }

  /* ── RIPPLE ── */
  function wireRipple() {
    nav.querySelectorAll('.rt-drawer-quick__tile,.rt-drawer-bottom').forEach(function(el){
      el.classList.add('rt-ripple-host');
      el.addEventListener('pointerdown',function(e){ var rect=el.getBoundingClientRect(),size=Math.max(rect.width,rect.height)*.65; var span=document.createElement('span');span.className='rt-ripple'; span.style.cssText='width:'+size+'px;height:'+size+'px;left:'+(e.clientX-rect.left-size/2)+'px;top:'+(e.clientY-rect.top-size/2)+'px;'; el.appendChild(span); setTimeout(function(){if(span.parentNode)span.parentNode.removeChild(span);},520); });
    });
  }

  /* ── CART BADGE POP ── */
  function wireCartBadgePop() {
    function pop(){ ['cart-count','cart-count--m'].forEach(function(id){ var el=document.getElementById(id);if(!el)return; el.style.animation='none';void el.offsetWidth; el.style.animation='rt-cart-pop 440ms cubic-bezier(0.22,1,0.36,1) both'; el.addEventListener('animationend',function(){el.style.animation='';},{once:true}); }); }
    document.addEventListener('cart:updated',pop); document.addEventListener('cart:refresh',pop);
    var b=document.getElementById('cart-count'); if(b&&window.MutationObserver) new MutationObserver(pop).observe(b,{childList:true,characterData:true,subtree:true});
  }

  /* ── DRAWER STATE ── */
  function observeDrawerState() {
    var was=html.classList.contains(DRAWER_OPEN_CLASS);
    new MutationObserver(function(){ var now=html.classList.contains(DRAWER_OPEN_CLASS); if(now&&!was) onDrawerOpen(); if(!now&&was) onDrawerClose(); was=now; }).observe(html,{attributes:true,attributeFilter:['class']});
  }

  /* ── HELPER: nav icon ── */
  function getNavIcon(text) {
    var t=(text||'').toLowerCase();
    for(var i=0;i<NAV_ICONS.length;i++){ var e=NAV_ICONS[i]; for(var j=0;j<e.kw.length;j++){ if(t.indexOf(e.kw[j])!==-1) return e.svg; } }
    return '<rect x="3" y="3" width="7" height="7" rx="1.5" stroke="currentColor" stroke-width="1.6"/><rect x="14" y="3" width="7" height="7" rx="1.5" stroke="currentColor" stroke-width="1.6"/><rect x="3" y="14" width="7" height="7" rx="1.5" stroke="currentColor" stroke-width="1.6"/><rect x="14" y="14" width="7" height="7" rx="1.5" stroke="currentColor" stroke-width="1.6"/>';
  }

  function getNavImg(text) {
    var t=(text||'').toLowerCase();
    for(var i=0;i<NAV_ICONS.length;i++){ var e=NAV_ICONS[i]; if(!e.img) continue; for(var j=0;j<e.kw.length;j++){ if(t.indexOf(e.kw[j])!==-1) return e.img; } }
    return null;
  }

  /* ── BUILD CUSTOM NAV ── */
  function buildCustomNav() {
    var cnav = document.getElementById('rt-cnav');
    if (!cnav || cnav.dataset.wired) return;
    cnav.dataset.wired = '1';

    /* Inject icons into tiles */
    cnav.querySelectorAll('.rt-tile').forEach(function(tile) {
      if (tile.querySelector('.rt-tile__icon')) return;
      var name = (tile.querySelector('.rt-tile__name') || {}).textContent || '';
      var lbl  = name.toLowerCase();

      var icon = document.createElement('div');
      icon.className = 'rt-tile__icon';
      icon.setAttribute('aria-hidden','true');

      var imgSrc = getNavImg(lbl);
      if (imgSrc) {
        icon.innerHTML = '<img src="'+imgSrc+'" alt="" width="20" height="20" style="display:block;object-fit:contain;opacity:0.82">';
      } else {
        var svg = '';
        for(var i=0;i<NAV_ICONS.length;i++){
          for(var j=0;j<NAV_ICONS[i].kw.length;j++){
            if(lbl.indexOf(NAV_ICONS[i].kw[j])>-1){svg=NAV_ICONS[i].svg;break;}
          }
          if(svg) break;
        }
        if(!svg) return;
        icon.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none">'+svg+'</svg>';
      }
      tile.insertBefore(icon, tile.firstChild);
    });

    /* Inject icons + special treatments into quick links */
    cnav.querySelectorAll('.rt-qlink').forEach(function(a) {
      var dot   = a.querySelector('.rt-qlink__dot');
      var label = a.querySelector('.rt-qlink__label');
      var lbl   = (label || {}).textContent || '';
      var lbl_l = lbl.toLowerCase().trim();
      var isSale = lbl_l.indexOf('sale')>-1||lbl_l.indexOf('offer')>-1||lbl_l.indexOf('deal')>-1;
      var isNew  = lbl_l.indexOf('new')>-1||lbl_l.indexOf('just in')>-1||lbl_l.indexOf('latest')>-1;
      var isBest = lbl_l.indexOf('best')>-1||lbl_l.indexOf('popular')>-1||lbl_l.indexOf('top')>-1;

      var iconBox = document.createElement('div');
      iconBox.className = 'rt-qlink__icon';
      iconBox.setAttribute('aria-hidden','true');

      var imgSrc = getNavImg(lbl_l);
      if (imgSrc) {
        iconBox.innerHTML = '<img src="'+imgSrc+'" alt="" width="16" height="16" style="display:block;object-fit:contain;opacity:0.82">';
      } else {
        var svg = getNavIcon(lbl_l);
        iconBox.innerHTML = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none">'+svg+'</svg>';
      }

      if (dot) a.replaceChild(iconBox, dot);
      else     a.insertBefore(iconBox, a.firstChild);

      /* Remove bare SVG chevrons, add classed one */
      Array.from(a.querySelectorAll('svg')).forEach(function(s){
        if(!s.closest('.rt-qlink__icon')&&!s.closest('.rt-qlink__chev')) s.remove();
      });
      if (!a.querySelector('.rt-qlink__chev')) {
        var chev = document.createElement('div');
        chev.className = 'rt-qlink__chev';
        chev.innerHTML = '<svg width="13" height="13" viewBox="0 0 24 24" fill="none"><path d="M9 6l6 6-6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
        a.appendChild(chev);
      }

      if (isSale) {
        a.classList.add('rt-qlink--sale');
        if (label) label.innerHTML = lbl + '<span class="rt-sale-badge">HOT</span>';
        return;
      }
      if (isNew) {
        a.classList.add('rt-qlink--new');
        if (label) label.innerHTML = lbl + '<span class="rt-new-badge">NEW</span>';
        return;
      }
      if (isBest) { a.classList.add('rt-qlink--best'); return; }
    });

    /* Click events */
    cnav.addEventListener('click', function(e) {
      var subItem = e.target.closest('.rt-tile__sub-item');
      if (subItem) {
        e.preventDefault(); e.stopPropagation();
        closeDrawer(); setTimeout(function(){ window.location.href = subItem.getAttribute('href'); }, 110);
        return;
      }
      var qlink = e.target.closest('.rt-qlink');
      if (qlink) {
        e.preventDefault(); e.stopPropagation();
        closeDrawer(); setTimeout(function(){ window.location.href = qlink.getAttribute('href'); }, 110);
        return;
      }
      var tile = e.target.closest('.rt-tile');
      if (!tile) return;
      if (e.target.closest('.rt-tile__sub')) return;

      var isOpen = tile.classList.contains('is-open');
      cnav.querySelectorAll('.rt-tile.is-open').forEach(function(t){
        t.classList.remove('is-open');
        t.classList.add('is-closing');
        setTimeout(function(){ t.classList.remove('is-closing'); }, 420);
      });

      if (!isOpen) {
        tile.classList.add('is-open');
        tile.querySelectorAll('.rt-tile__sub-img').forEach(function(img) {
          img.addEventListener('error', function onErr() {
            img.removeEventListener('error', onErr);
            var nameEl = img.closest('.rt-tile__sub-item') && img.closest('.rt-tile__sub-item').querySelector('span');
            var initial = ((nameEl && nameEl.textContent)||'?').trim().charAt(0).toUpperCase();
            var av = document.createElement('div'); av.className='rt-tile__sub-avatar'; av.textContent=initial;
            if(img.parentNode) img.parentNode.replaceChild(av,img);
          }, {once:true});
          img.loading='eager';
          var src=img.getAttribute('src'); if(src&&!img.complete){img.src='';img.src=src;}
        });
        var rect=tile.getBoundingClientRect(), sz=Math.max(rect.width,rect.height)*.7;
        var rip=document.createElement('span'); rip.className='rt-tile-ripple';
        rip.style.cssText='width:'+sz+'px;height:'+sz+'px;left:'+(e.clientX-rect.left-sz/2)+'px;top:'+(e.clientY-rect.top-sz/2)+'px;';
        tile.appendChild(rip); setTimeout(function(){if(rip.parentNode)rip.parentNode.removeChild(rip);},550);
        setTimeout(function(){tile.scrollIntoView({behavior:'smooth',block:'nearest'});},60);
      }
    });
  }

  function onDrawerOpen() {
    buildCustomNav();
    injectRiderAvatar();
    forceHideNavHeaders();
    updateGreeting();
    refreshOffer();
    setStaggerIndex();
    if(hero) hero.classList.remove('is-scrolled');
    closeGarageSelector();
    showCloseButton();
  }
  function onDrawerClose() { closeGarageSelector(); hideCloseButton(); }

  document.addEventListener('cart:updated',refreshOffer);
  document.addEventListener('cart:refresh',refreshOffer);
  document.addEventListener('cart:added',  refreshOffer);

})();